import React from "react";
import { Draggable } from "react-beautiful-dnd";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const GroupCard = (props) => {

    const { card, index } = props;

    const teamLogo = (card && card.logoUrl) ? card.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"

    return (
        <Draggable draggableId={card.id} index={index}>
            {(provided, snapshot) => {

                const bgClass = snapshot.isDragging ? "bg-light" : "bg-transparent";
                return (
                    <div className={"col-12 rounded-lg border-bottom  p-0 pt-2 pb-2 " + bgClass}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                    >
                        <div className="media">
                            <div className="align-self-center mr-1" style={{
                                backgroundImage: `url(${teamLogo})`,
                                height: 25,
                                width: 25,
                                minWidth: 25,
                                backgroundPosition: 'center',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'

                            }} />
                            {/* <img className="align-self-center mr-1" src={(card && card.logoUrl) || teamLogo} height="25" width="25" alt="" /> */}
                            <span className="flex-fill text-wrap text-truncate mb-0 align-self-center">{card.title}</span>
                            <FontAwesomeIcon className="align-self-center mr-1 text-secondary" icon={faBars} />
                        </div>

                    </div>

                )
            }}
        </Draggable>
    )
}

export default GroupCard;